var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.25 5.133a9.5 9.5 0 0 1-2.651.717 4.57 4.57 0 0 0 2.03-2.512c-.907.53-1.899.903-2.932 1.101A4.65 4.65 0 0 0 16.327 3c-2.552 0-4.616 2.034-4.616 4.542a4.4 4.4 0 0 0 .12 1.036A13.16 13.16 0 0 1 2.314 3.83a4.5 4.5 0 0 0-.628 2.283c0 1.575.822 2.967 2.062 3.782a4.6 4.6 0 0 1-2.099-.567v.056c0 2.204 1.594 4.036 3.703 4.454-.396.105-.805.159-1.215.159q-.439 0-.868-.085c.586 1.805 2.293 3.118 4.315 3.155a9.36 9.36 0 0 1-6.836 1.88A13.06 13.06 0 0 0 7.815 21c8.502 0 13.146-6.923 13.146-12.928q0-.297-.015-.586a9.3 9.3 0 0 0 2.303-2.353"
  })));
};
export default SvgTwitter;